import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { createStaticRanges, Range, StaticRange } from 'react-date-range';
import {
  endOfISOWeek,
  isSameDay,
  startOfDay,
  endOfDay,
  startOfISOWeek,
  subDays,
  startOfQuarter,
  endOfQuarter,
  subQuarters,
  startOfYear,
  endOfYear,
  subYears
} from 'date-fns';

export const createFullRangeStaticRange = (firstDate: Date): StaticRange => ({
  label: 'Full Range',
  range: (): Range => ({
    startDate: startOfDay(firstDate),
    endDate: endOfDay(new Date()),
    key: 'selection'
  }),
  isSelected: (selectedRange: Range): boolean => {
    const { startDate, endDate } = selectedRange;
    if (startDate && endDate) {
      return (
        isSameDay(startDate, startOfDay(firstDate)) &&
        isSameDay(endDate, endOfDay(new Date()))
      );
    }
    return false;
  }
});

const getCurrentQuarterRange = () => ({
  startDate: startOfQuarter(new Date()),
  endDate: endOfQuarter(new Date()),
  key: 'selection'
});

const getLastQuarterRange = () => ({
  startDate: startOfQuarter(subQuarters(new Date(), 1)),
  endDate: endOfQuarter(subQuarters(new Date(), 1)),
  key: 'selection'
});

const getCurrentYearRange = () => ({
  startDate: startOfYear(new Date()),
  endDate: endOfYear(new Date()),
  key: 'selection'
});

const getLastYearRange = () => ({
  startDate: startOfYear(subYears(new Date(), 1)),
  endDate: endOfYear(subYears(new Date(), 1)),
  key: 'selection'
});

export const weekRanges = createStaticRanges([
  {
    label: 'This Week',
    range: () => ({
      startDate: startOfISOWeek(new Date()),
      endDate: endOfISOWeek(new Date()),
      key: 'selection'
    }),
    isSelected: (weekRange) => {
      const { startDate, endDate } = weekRange;
      if (startDate && endDate) {
        return (
          isSameDay(startDate, startOfISOWeek(new Date())) &&
          isSameDay(endDate, endOfISOWeek(new Date()))
        );
      }
      return false;
    }
  },
  {
    label: 'Last Week',
    range: () => ({
      startDate: startOfISOWeek(subDays(new Date(), 7)),
      endDate: endOfISOWeek(subDays(new Date(), 7)),
      key: 'selection'
    }),
    isSelected: (weekRange) => {
      const { startDate, endDate } = weekRange;
      if (startDate && endDate) {
        return (
          isSameDay(startDate, startOfISOWeek(subDays(new Date(), 7))) &&
          isSameDay(endDate, endOfISOWeek(subDays(new Date(), 7)))
        );
      }
      return false;
    }
  }
]);

export const quarterAndYearRanges = createStaticRanges([
  {
    label: 'This Quarter',
    range: getCurrentQuarterRange,
    isSelected: (quarterRange) => {
      const { startDate, endDate } = quarterRange;
      if (startDate && endDate) {
        return (
          isSameDay(startDate, startOfQuarter(new Date())) &&
          isSameDay(endDate, endOfQuarter(new Date()))
        );
      }
      return false;
    }
  },
  {
    label: 'Last Quarter',
    range: getLastQuarterRange,
    isSelected: (quarterRange) => {
      const { startDate, endDate } = quarterRange;
      if (startDate && endDate) {
        return (
          isSameDay(startDate, startOfQuarter(subQuarters(new Date(), 1))) &&
          isSameDay(endDate, endOfQuarter(subQuarters(new Date(), 1)))
        );
      }
      return false;
    }
  },
  {
    label: 'This Year',
    range: getCurrentYearRange,
    isSelected: (yearRange) => {
      const { startDate, endDate } = yearRange;
      if (startDate && endDate) {
        return (
          isSameDay(startDate, startOfYear(new Date())) &&
          isSameDay(endDate, endOfYear(new Date()))
        );
      }
      return false;
    }
  },
  {
    label: 'Last Year',
    range: getLastYearRange,
    isSelected: (yearRange) => {
      const { startDate, endDate } = yearRange;
      if (startDate && endDate) {
        return (
          isSameDay(startDate, startOfYear(subYears(new Date(), 1))) &&
          isSameDay(endDate, endOfYear(subYears(new Date(), 1)))
        );
      }
      return false;
    }
  }
]);
